import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PetitionEditPagePrefetchedDataProps } from 'src/app/pages/petitionEditV2/pageContext';
import { PetitionEditPageContextProvider, prefetchPageContext } from 'src/app/pages/petitionEditV2/pageContext';
import { useCurrentUserRole } from 'src/app/shared/hooks/session';

import { Layout } from '../layout';

import { PetitionEditErrorHandler } from './ErrorHandler';

export const PetitionEdit = withPrefetchedData(
	function PetitionEdit({ prefetchedData }: PetitionEditPagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		const isProductMember = useCurrentUserRole('product');
		const isCampaignsMember = useCurrentUserRole('campaigns');
		const includeUndiscoverableTags = isProductMember || isCampaignsMember;

		return (
			<PetitionEditPageContextProvider
				slug={slug}
				includeUndiscoverableTags={includeUndiscoverableTags}
				prefetchedData={prefetchedData}
				errorHandler={PetitionEditErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PetitionEditPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
